export function createXLSheetdata(ticketList) {
    ticketList.find((ticketDetails, index) => {
                
               

                ticketList[index].Created=ticketList[index].created
                delete ticketList[index]['created']

                ticketList[index].Employee_ID=ticketList[index].employee_id
                delete ticketList[index]['employee_id']

                ticketList[index].Employee_Name=ticketList[index].employee_name
                delete ticketList[index]['employee_name']

                ticketList[index].Contact_No=ticketList[index].contact_no
                delete ticketList[index]['contact_no']

                ticketList[index].Work_Location=ticketList[index].work_location
                delete ticketList[index]['work_location']

                ticketList[index].City=ticketList[index].city_name
                delete ticketList[index]['city_name']

                ticketList[index].Issuer_Reason=ticketList[index].issue_reason
                delete ticketList[index]['issue_reason']

                ticketList[index].Issuer_Remarks=ticketList[index].issue_remarks
                delete ticketList[index]['issue_remarks']

                ticketList[index].Type=ticketList[index].type
                delete ticketList[index]['type']

                ticketList[index].Status=ticketList[index].status
                delete ticketList[index]['status']

                ticketList[index].HR_Remarks=ticketList[index].hr_remarks
                delete ticketList[index]['hr_remarks']

                ticketList[index].Assigned_HR=ticketList[index].assigned_hr
                delete ticketList[index]['assigned_hr']

                delete ticketList[index]['id']


                return false
            })   
            return ticketList
}




// WEBPACK FOOTER //
// ./src/modules/HR/services/helpers.js